"use strict";
var card = document.querySelectorAll(".product__card");
for(var i = 2; i < card.length; i = i + 4)card[i].classList.add("right");

//# sourceMappingURL=index.cd1b3e7f.js.map
